import { useState, useEffect, useRef } from "react";
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import ModalManager from "@ebay/nice-modal-react";
import "./MemoCard.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import MemoFormModal from "../../MemoFormModal/MemoFormModal"
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import { formatDate } from '/src/utils/formatDate';
import { getIconByView, getTitleByView } from "../../data/MemoViewTypes";
import memoService from "../../services/memoService";
import { addFavoriteMemo, removeFavoriteMemo } from "../../hooks/storageMemoHelper";

function MemoCard({ memo, mode = "edit", view, postbackAction, postbackFavorites, isFav }) {


    const IS_CREATING_MODE = mode == "create";

    let _data = {
        title: memo ? memo.name : "Title",
        content: memo ? memo.description : "Content",
        createdAt: memo ? formatDate(memo.created_at) : "",
        color: memo ? memo.category.color : "#0e7aed",
        iconCategory: memo ? memo.category.icon : "fas fas-lightbulb"
    }

    const [data, setData] = useState(_data);

    const ref = useRef();
    const ref_fav = useRef(memo?.id);
    const [isFavorite, setIsFavorite] = useState(isFav);
    const [isHovering, setHovering] = useState(false);
    const [typingTimer, setTypingTimer] = useState(null);

    const toast = useToastDispatchContext();

    const { editMemo, deleteMemo } = memoService;

    const ref_title = useRef(memo?.id + "_title");
    const ref_content = useRef(memo?.id + "_content");

    const onClickAddFavorite = () => {

        if (!isFavorite == true) {
            addFavoriteMemo(memo.id)
        }
        else {
            removeFavoriteMemo(memo.id)
        }
        setIsFavorite(!isFavorite);
        postbackFavorites();
    }

    const onClickDelete = async () => {
        var name = data.title
        await ModalManager.show(ApiModal, {
            title: 'Delete memo ' + name,
            body: 'Do you really want to delete the memo ' + name + " ?",
            api: {
                request: deleteMemo,
                param: [memo.id]
            },
            buttons: [
                { className: 'validate', label: 'Cancel', style: { marginRight: '20px' } },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
        }).then(() => deleteAction())
    };
    const deleteAction = () => {
        toast.success('Success', 'The memo has been deleted');
        postbackAction()
    }
    const onClickUpdate = () => NiceModal.show(MemoFormModal, {
        memo: memo
    }).then(() => postbackAction());

    const onClickAdd = () => NiceModal.show(MemoFormModal, {
        mode: mode,
        view: view

    }).then(() => postbackAction())

    const hexToRGB = (hex, opacity = 0.2) => { //https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g},${b}, ${opacity})`
    }
    const getDescriptionWithUrls = () => {
        const links = ref_content.current.querySelectorAll('a');
        let fullText = ref_content.current.textContent;

        // Remplacer chaque domaine visible par l'URL complète pour obtenir le texte brut
        links.forEach(link => {
            const domain = link.textContent;
            const fullUrl = link.getAttribute('data-url');
            fullText = fullText.replace(domain, fullUrl);
        });
        return fullText;
    }

    const saveData = () => {

        let descriptionWithUrl = getDescriptionWithUrls();

        let dataToSend = { name: ref_title.current.textContent.trim(), description: descriptionWithUrl.trim() }
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(async () => {
            let [response, error] = await editMemo(memo.id, dataToSend)
            if (error !== null) {
                console.log(error);
                toast.error('Error', error.data);
                return;
            }
            toast.success('Memo\'s updated', 'The value of the memo has been updated !', 5000);
            postbackAction();

        }, 1500));

    }

    const handleLinkClick = (event) => {
        event.preventDefault();
        const url = event.target.getAttribute('data-url');
        window.open(url);
    };

    const clearContent = (txt) => {
        const urlRegex = /(https?:\/\/(?:www\.)?([^\s/$.?#].[^\s]*))/gi;

        const newContent = txt.replace(urlRegex, (match, url, domain) => {
            return `<a href="${url}" style="color: ${data.color};cursor: pointer" title=${url} target="_blank" rel="noopener noreferrer" data-url="${url}">${domain}</a>`;
        });
        ref_content.current.innerHTML = newContent;

        const links = ref_content.current.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', handleLinkClick);
        });
    }

    useEffect(() => {
        if (memo != null) {
            clearContent(memo.description);
        }
    }, [memo])

    const separator = <div className="memo_separator" style={{ backgroundImage: `linear-gradient(to right, ${hexToRGB(data.color, 0.2)}, ${hexToRGB(data.color, 0)}, ${hexToRGB(data.color, 0.2)})` }} />

    return (
        <div id={memo?.id + "v-"} ref={ref} key={"mc-" + memo?.id + ref} className="memo_card memo_scrollable_container" style={{ backgroundColor: hexToRGB(data.color) }} onMouseEnter={() => { setHovering(true) }} onMouseLeave={() => { setHovering(false) }}>

            <div className="memo_corner" style={{ borderLeftColor: hexToRGB(data.color) }} />

            {!IS_CREATING_MODE ?
                <div style={{ height: "100%" }}>
                    <i className={"memo_category_icon " + data.iconCategory} style={{ color: data.color }} title={memo.category.name} aria-hidden="true"></i>
                    {
                        (isHovering || isFavorite) && <i ref={ref_fav} key={memo.id} className={"memo_favorite_icon " + (isFavorite ? "fas" : "far") + " fa-star"} style={{ color: data.color }} aria-hidden="true" onClick={() => onClickAddFavorite()}></i>
                    }

                    <div className="memo_title_container">
                        <div ref={ref_title} contentEditable={true} spellCheck="false" className="memo_title" suppressContentEditableWarning={true} onInput={() => { saveData() }}> {data.title}</div>
                    </div>
                    {separator}
                    <br />
                    <div className="memo_content_container">
                        <span ref={ref_content} contentEditable={true} spellCheck="false" className="memo_content" suppressContentEditableWarning={true} onInput={() => { saveData() }}> {data.content}</span>
                    </div>
                    {separator}
                    <div className="memo_footer_container">
                        <i className={"memo_icon_view " + getIconByView(memo.view.view)} title={getTitleByView(memo.view.view)} style={{ color: data.color }} aria-hidden="true"></i>
                        <div className="memo_date_creation"> {data.createdAt}</div>
                        <div className="memo_options_container" style={{ display: isHovering ? "" : "none" }}>
                            <IconButton className={"main-iconButton add-hover"} style={{ color: data.color }} icon="fas fa-cog" onClick={onClickUpdate} />
                            <IconButton className={"main-iconButton remove-hover"} style={{ color: data.color }} icon="fas fa-trash" onClick={onClickDelete} />
                        </div>
                    </div>
                </div> :

                <div className="add_memo_container">

                    <IconButton className={"main-iconButton memo_hover_add"} style={{ color: data.color }} icon="fas fa-plus" onClick={onClickAdd} />
                </div>

            }
        </div >
    );
}

export default MemoCard;